import React, { useRef, useState } from 'react'
import { Animated, StyleSheet, ImageBackground } from 'react-native'
import CoverScreen from './components/CoverScreen/CoverScreen'
import GameBoard from './components/GameBoard/GameBoard'
// eslint-disable-next-line camelcase
import { useFonts, OpenSans_400Regular, OpenSans_700Bold } from '@expo-google-fonts/open-sans'

const woodBG = require('./assets/board/wood_bg_01.jpg')

const App = () => {
  // fadeAnim will be used as the value for opacity. Initial Value: 0
  const fadeAnim = useRef(new Animated.Value(1)).current
  const [showCover, setShowCover] = useState(true)
  const [showDeck, setShowBoard] = useState(false)

  useFonts({
    // eslint-disable-next-line camelcase
    OpenSans_400Regular, OpenSans_700Bold
  })

  const fadeOut = () => {
    // Will change fadeAnim value to 0 in 3 seconds
    Animated.timing(fadeAnim, {
      toValue: 0,
      duration: 500,
      useNativeDriver: false
    }).start(({ finished }) => {
      if (finished) { setShowCover(false) }
    })
  }

  const startGame = () => {
    setShowBoard(true)
    fadeOut()
  }

  return (
      <ImageBackground source={woodBG} resizeMode={'repeat'} style={styles.background}>
        { showDeck &&
          <GameBoard />
        }
        { showCover &&
          <Animated.View style={[styles.fadingContainer, { opacity: fadeAnim }]}>
              <CoverScreen onStartGame={startGame} />
          </Animated.View>
        }
      </ImageBackground>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1
  },
  fadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  },
  background: {
    width: '100%',
    height: '100%',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20
  }
})

export default App

export const initialGameInfo = {
  cardsLeft: 24,
  co2Traffic: 5,
  co2Public: 5,
  co2Wastes: 1,
  co2Private: 10,
  co2Energy: 2,
  cashTraffic: 4,
  cashPublic: 7,
  cashWastes: 2,
  cashPrivate: 6,
  cashEnergy: 3,
  totalReductions: 0,
  totalSavings: 0,
  gameTimeout: 60,
  co2OpacityReductionMax: 0.5,
  co2ReductionsMax: 23,
  savingsMax: 22
}
